import { arcadeVi } from "../../i18n/arcade.vi.ts";
import { vi } from "../../i18n/vi.ts";
import { Art } from "../components/common.tsx";
import "../../styles/arcade.css";

/** Coins in the kept line and the three-star target, under the level title. */
export function ClawHudLine({ coins, target, focus }: { coins: number; target: number; focus: boolean }) {
  return (
    <span className={`puzzle-hud__moves ${focus ? "hud-focus" : ""}`} data-testid="claw-coins">
      <Art id="arcade.token" className="ico-inline" />
      {arcadeVi.coins(coins)}
      <span className="puzzle-hud__target" aria-label={vi.puzzle.target(target)}>
        <Art id="icon.target" className="ico-inline" />
        {target}
      </span>
    </span>
  );
}

/** A glass wall stranded a wished friend: no line wins from here any more. */
export function ClawStuck() {
  return (
    <p className="claw-stuck" role="status" data-testid="claw-stuck">
      {arcadeVi.stuck}
    </p>
  );
}
